import { Navigate, Route, Routes } from 'react-router-dom';

interface props {
    children: JSX.Element[] | JSX.Element;
    redirect: string;
}

export const NotFoundRoutes = ({ children, redirect }: props) => {
    return (
        <Routes>
            {children}
            <Route path='*' element={<Navigate replace to={redirect} />} />
        </Routes>
    );
};
